import {
	currentUserMeetsUserLevel,
	UserLevel,
} from '@netx/core-user-next/utils/currentUserMeetsUserLevel';
import {
	currentUserHasAccess,
	PermissionName,
} from '@netx/core-permissions-next';
import {attributeHistoryEnabled} from './attributeHistoryEnabled';

export const canViewAttributeHistory = (): boolean => {
	if (!attributeHistoryEnabled()) return false;
	if (!currentUserMeetsUserLevel(UserLevel.PRODUCER)) return false;
	return currentUserHasAccess(PermissionName.VIEW_ATTRIBUTE_HISTORY);
};
